import React from 'react'
import "./blog.css"
import { Article } from '../../components'
import {blog01 , blog02 , blog03 , blog04 , blog05 } from "./imports"


const Blog = () => {
  return (
    <div className="gpt3__blog section__padding" id="blog">
      <div className="gpt3__blog-heading">
        <h1 className="gradient__text">
        A lot is happening, 
We are blogging about it.
        </h1>
      </div>
      <div className="gpt3__blog-container">
        <div className="gpt3__blog-container-groupA">
        <Article imgUrl={blog01} date="Sep 26, 2022" title="GPT-3 and Open  AI is the future. Let us exlore how it is?"  />
        </div>
        <div className="gpt3__blog-container-groupB">
          <Article imgUrl={blog02} date={"Oct 21, 2022"} title="Banning ChatGPT will do more harm than good"/>
          <Article imgUrl={blog03} date="Jan 6, 2023" title="ChatGPT cheat sheet: Complete guide for 2023"/>
          <Article imgUrl={blog04} date="Mar , 2023" title="AI is no Shakespeare. Why ChatGPT, other tools are unlikely to take your writing job"/>
          <Article imgUrl={blog05} date="Apr 01, 2023" title="ChatGPT safe from cheating, contend ed tech firms; teachers have doubts"/>
        </div>
      </div>
    </div>
  )
}

export default Blog